export default {
  data() {
    return {
      images: {
        data: [],
      },
    };
  },
  methods: {
    populateWithImages(images) {
      images.forEach((image) => {
        // Add selected property. Is used for multiple select
        image.selected = false;

        this.images.data.push(image);
      });
    },
    addImageNewFile(image) {
      image.selected = false;

      this.images.data.unshift(image);
    },
    getImageMediaFile(id) {
      return this.images.data.find(media => media.id === id);
    },
    updateImageMedia(id, params) {
      this.images.data.find((image) => {
        if (image.id === id) {
          image.title = params.title;
          image.description = params.description;
        }
      });
    },
    deleteImageMedia(id) {
      this.images.data = this.images.data.filter(media => media.id !== id);
    },
  },
};
